import AdminComp from '../Components/AdminComp/AdminComp';

function AdminPage() {

    return (
        <div>
            <AdminComp/>
        </div>
    );
}

export default AdminPage;